import { render, staticRenderFns } from "./exchangeReview.vue?vue&type=template&id=e25bcdf0&scoped=true"
import script from "./exchangeReview.vue?vue&type=script&lang=js"
export * from "./exchangeReview.vue?vue&type=script&lang=js"
import style0 from "./exchangeReview.vue?vue&type=style&index=0&id=e25bcdf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25bcdf0",
  null
  
)

export default component.exports